<app-badge>
  <app-source [item]="metric$ | async"></app-source>
</app-badge>
